(function () {
  if (window.BrCaprazBundleReady) return;
  window.BrCaprazBundleReady = true;

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getCartNotification() {
    return document.querySelector('cart-notification');
  }

  function getSectionsToRender() {
    var cart = getCartDrawer() || getCartNotification();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function getRenderedElement(html, selector) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function syncHeaderCartCount() {
    var headerCart = document.getElementById('cart-icon-bubble');
    var drawerCount = document.querySelector('#CartDrawer .br-cart-count');
    if (!headerCart || !drawerCount) return;

    var itemCount = parseInt(drawerCount.textContent, 10) || 0;
    var countBubble = headerCart.querySelector('.cart-count-bubble');

    if (itemCount < 1) {
      if (countBubble) countBubble.remove();
      return;
    }

    if (!countBubble) {
      countBubble = document.createElement('div');
      countBubble.className = 'cart-count-bubble';
      countBubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      headerCart.appendChild(countBubble);
    }

    var visibleCount = countBubble.querySelector('[aria-hidden="true"]');
    var accessibleCount = countBubble.querySelector('.visually-hidden');
    if (visibleCount) visibleCount.textContent = itemCount < 100 ? itemCount : '';
    if (accessibleCount) accessibleCount.textContent = itemCount + ' ürün';
  }

  function renderCart(sectionsState, activeElement, variantOne, variantTwo) {
    var drawer = getCartDrawer();
    var drawerMarkup = getRenderedElement(sectionsState['cart-drawer'], '#CartDrawer');
    var currentDrawer = document.getElementById('CartDrawer');

    if (drawer && drawerMarkup && currentDrawer) {
      currentDrawer.innerHTML = drawerMarkup.innerHTML;
      drawer.classList.remove('is-empty');

      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');

      var items = drawer.querySelector('cart-drawer-items');
      if (items) {
        items.classList.remove('is-empty', 'cart__items--disabled');
        items.removeAttribute('aria-busy');
        items.scrollTop = 0;
      }

      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof drawer.close === 'function') {
        overlay.addEventListener('click', drawer.close.bind(drawer));
      }

      var addedItem = drawer.querySelector('[data-variant-id="' + variantOne + '"]') ||
        drawer.querySelector('[data-variant-id="' + variantTwo + '"]');
      if (addedItem) {
        var addedRow = addedItem.closest('.cart-item');
        if (addedRow && typeof addedRow.scrollIntoView === 'function') {
          addedRow.scrollIntoView({ block: 'nearest' });
        }
      }
    }

    if (sectionsState['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var renderedBubble = getRenderedElement(sectionsState['cart-icon-bubble'], '#cart-icon-bubble');
      if (bubble && renderedBubble) bubble.innerHTML = renderedBubble.innerHTML;
    }

    syncHeaderCartCount();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (activeElement && typeof activeElement.focus === 'function') activeElement.focus();
  }

  function fetchFreshSections(sectionIds) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var separator = root.indexOf('?') === -1 ? '?' : '&';
    var url = root + separator + 'sections=' + encodeURIComponent(sectionIds.join(','));

    return fetch(url, {
      cache: 'no-store',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error(String(response.status));
      return response.json();
    });
  }

  function openCart() {
    var drawer = getCartDrawer();
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && typeof bubble.click === 'function') bubble.click();
  }

  function resetButton(button, label, delay) {
    window.setTimeout(function () {
      button.textContent = label;
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }, delay);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-br-bundle-form]');
    if (!form) return;

    var button = form.querySelector('[data-br-ekle]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    var variantOne = Number(button.dataset.v1);
    var variantTwo = Number(button.dataset.v2);
    if (!variantOne || !variantTwo) return;

    event.preventDefault();

    var firstLabel = button.textContent.trim();
    var activeElement = document.activeElement;
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = button.dataset.bekle || 'Ekleniyor...';

    var sections = getSectionsToRender();
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [
          { id: variantOne, quantity: 1 },
          { id: variantTwo, quantity: 1 }
        ]
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) throw json;
          return json;
        });
      })
      .then(function () {
        return fetchFreshSections(sections);
      })
      .then(function (sectionsState) {
        if (!sectionsState['cart-drawer']) throw new Error('cart-drawer');
        renderCart(sectionsState, activeElement, variantOne, variantTwo);
      })
      .then(function () {
        button.textContent = button.dataset.tamam || 'Sepete eklendi';
        openCart();
        resetButton(button, firstLabel, 2200);
      })
      .catch(function () {
        button.textContent = button.dataset.hata || 'Tekrar deneyin';
        resetButton(button, firstLabel, 2200);
        window.location.assign(cartUrl);
      });
  });
})();

